var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "160px",
    width: "160px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6A6F95"
    },
    cx: 256,
    cy: 176.683,
    r: 43.368
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEEF2"
    },
    d: "M256,234.276c-31.755,0-57.59-25.835-57.59-57.59s25.835-57.591,57.59-57.591 s57.59,25.835,57.59,57.59S287.755,234.276,256,234.276z M256,147.538c-16.071,0-29.146,13.074-29.146,29.146 s13.074,29.147,29.146,29.147c16.071,0,29.146-13.074,29.146-29.146S272.071,147.538,256,147.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEEF2"
    },
    d: "M256,352.361c-3.452,0-6.903-1.25-9.624-3.752c-4.005-3.681-98.091-91.092-98.091-172.264 c0-12.658,2.179-25.06,6.474-36.857c2.688-7.378,10.849-11.184,18.23-8.498c7.38,2.688,11.184,10.85,8.498,18.23 c-3.157,8.668-4.757,17.795-4.757,27.123c0,54.928,56.306,118.276,79.299,141.852c5.78-5.898,13.651-14.29,22.168-24.411 c5.057-6.012,14.029-6.784,20.039-1.725c6.01,5.059,6.781,14.029,1.724,20.039c-18.411,21.878-33.717,35.941-34.359,36.53 C262.884,351.118,259.442,352.361,256,352.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEEF2"
    },
    d: "M318.921,276.814c-2.61,0-5.249-0.717-7.615-2.221c-6.629-4.213-8.589-13.002-4.375-19.631 c18.806-29.592,28.341-56.041,28.341-78.616c0-43.709-35.56-79.27-79.27-79.27c-17.007,0-33.213,5.302-46.868,15.333 c-6.33,4.649-15.232,3.288-19.881-3.044c-4.651-6.329-3.288-15.231,3.042-19.881c18.571-13.642,40.602-20.853,63.708-20.853 c59.393,0,107.715,48.321,107.715,107.715c0,28.065-11.028,59.647-32.778,93.872C328.228,274.482,323.624,276.814,318.921,276.814z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6A6F95"
    },
    d: "M403.2,405.333H62.578v2.64c17.95,6.346,30.815,23.458,30.815,43.583l0,0 c0,20.123-12.864,37.235-30.815,43.583v2.64H403.2c25.527,0,46.222-20.695,46.222-46.222l0,0 C449.422,426.028,428.727,405.333,403.2,405.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDEEF2"
    },
    d: "M358.4,0H62.578c-7.855,0-14.222,6.369-14.222,14.222v335.171c0,7.854,6.367,14.222,14.222,14.222 S76.8,357.247,76.8,349.393V28.444h281.6c42.348,0,76.8,34.453,76.8,76.8v295.067c-9.287-5.821-20.254-9.2-32-9.2H62.578 c-7.855,0-14.222,6.369-14.222,14.222v2.64c0,6.027,3.799,11.401,9.482,13.409c12.76,4.511,21.333,16.637,21.333,30.174 s-8.573,25.663-21.333,30.174c-5.683,2.008-9.482,7.38-9.482,13.409v2.64c0,7.854,6.367,14.222,14.222,14.222H403.2 c33.33,0,60.444-27.115,60.444-60.444V105.244C463.644,47.212,416.432,0,358.4,0z M403.2,483.556H98.426 c5.87-9.395,9.189-20.423,9.189-32s-3.318-22.605-9.189-32H403.2c17.646,0,32,14.356,32,32S420.846,483.556,403.2,483.556z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSvgrepoCom);
export default __webpack_public_path__ + "static/media/book-svgrepo-com.b88235182be110b29ba3e706c23fff34.svg";
export { ForwardRef as ReactComponent };